export default __webpack_public_path__ + "static/media/texture-lg.eeb3fa46.png";